import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { DiscoveryProfile } from "@/types";

// #226: Discovery-Profil eines Agenten (CV + Flags) — Sub-Resource am Agent.
// GET /agents/:id/discovery/profile (Admin/Owner/Agent-self → hier Admin-UI).
export function useDiscoveryProfile(agentId: string | undefined): UseQueryResult<DiscoveryProfile> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: agentId
      ? queryKeys.subResource("agents", agentId, "discovery")
      : ["resources", "agents", "_invalid", "discovery"],
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<DiscoveryProfile>(`/agents/${agentId}/discovery/profile`);
    },
    enabled: !!agentId && !!session,
  });
}
